import { useGetCurrentUserCapacityDataQuery } from '../../../__generated__/chirp/com/hubspot/cv/assignments/rpc/UserCapacityLimitsV2Service.hooks';
import { useIsUngatedForUserLevelCapacityLimitsTicketType } from '../../auth/hooks/useGates';
import { useHasCapacityLimitsV2ReadScope } from '../../auth/hooks/useScopes';
export const useGetCurrentUserCapacityDataRpc = () => {
  const isUngatedForUserLevelCapacityLimitsTicketType = useIsUngatedForUserLevelCapacityLimitsTicketType();
  const hasCapacityLimitsV2ReadScope = useHasCapacityLimitsV2ReadScope();
  const {
    data,
    loading,
    error
  } = useGetCurrentUserCapacityDataQuery({
    skip: !hasCapacityLimitsV2ReadScope || !isUngatedForUserLevelCapacityLimitsTicketType
  });
  return {
    currentUserCapacity: data,
    loading,
    error
  };
};